export default {"src":"/_next/static/media/blog-icon.335e56ef.svg","height":30,"width":35,"blurWidth":0,"blurHeight":0};